import {
  CircularProgress,
  FormControl,
  FormLabel,
  RadioGroup,
} from '@material-ui/core';

import { RadioOption, SideBarDialog } from 'shared/components';
import { ItemInfoCardWithAvatar } from 'features/mozart-notifications/components';

import { useMozartDefectSolved } from './hooks';

import { SOLVED_MODE_OPTION_MAP } from 'features/mozart-notifications/domain';
import makeClasses from './MozartDefectSolved.style';

import type { SideBarDialogProps } from 'shared/components';
import type { MozartComplaint } from 'features/mozart-notifications/domain';

export function MozartDefectSolved(props: Props) {
  const { complaint, ...restProps } = props;

  const {
    lang,
    isLoading,
    isDisabled,
    isOtherOption,
    textareaValue,
    MAX_LENGTH,
    handleOnClickSend,
    handleOptionChange,
    handleTextareaChange,
  } = useMozartDefectSolved({ complaint, onClose: props.onClose });

  const _classes = makeClasses();

  return (
    <SideBarDialog
      aria-label='mozart-defect-solved-dialog'
      headerTitle={lang.dialog.header.title}
      classesHeader={{ title: _classes.headerDialogTitle }}
      posNav={
        <ItemInfoCardWithAvatar
          info={{
            title: complaint.title,
            imageUrl: complaint.imageUrl,
            description: complaint.description,
          }}
        />
      }
      actions={{
        primaryBtn: {
          children: lang.dialog.action.primaryBtn,
          disabled: isDisabled,
          endIcon: isLoading ? <CircularProgress size='1rem' /> : undefined,
          onClick: handleOnClickSend,
        },
      }}
      {...restProps}
    >
      <FormControl fullWidth component='fieldset'>
        <FormLabel component='legend' className={_classes.legend}>
          {lang.form.legend}
        </FormLabel>
        <RadioGroup
          aria-label='defect-solved'
          name='defect-solved'
          onChange={handleOptionChange}
          className={_classes.radioGroup}
        >
          <RadioOption
            variant='default'
            title={lang.form.option.cooking.title}
            value={SOLVED_MODE_OPTION_MAP.cooking_adjusted}
            classes={{ label: { title: _classes.radioOptionLabelTitle } }}
          />
          <RadioOption
            variant='default'
            title={lang.form.option.stock.title}
            value={SOLVED_MODE_OPTION_MAP.stock_updated}
            classes={{ label: { title: _classes.radioOptionLabelTitle } }}
          />
          <RadioOption
            variant='default'
            title={lang.form.option.packaging.title}
            value={SOLVED_MODE_OPTION_MAP.packaging_improved}
            classes={{ label: { title: _classes.radioOptionLabelTitle } }}
          />
          <RadioOption
            variant='default'
            title={lang.form.option.other.title}
            value={SOLVED_MODE_OPTION_MAP.other}
            classes={{ label: { title: _classes.radioOptionLabelTitle } }}
          />
          {isOtherOption && (
            <div className={_classes.textAreaContainer}>
              <textarea
                maxLength={MAX_LENGTH}
                className={_classes.textArea}
                onChange={handleTextareaChange}
                placeholder={lang.form.option.other.placeholder}
              />
              <div className={_classes.characterCount}>
                {MAX_LENGTH - textareaValue.length}{' '}
                {lang.form.option.other.numberOfCharacters}
              </div>
            </div>
          )}
        </RadioGroup>
      </FormControl>
    </SideBarDialog>
  );
}

interface Props extends Partial<SideBarDialogProps> {
  complaint: MozartComplaint;
}
